/* SÈVE — comportements des pages SÈVE (accueil et fiche produit). */

const SEVE_SECTION_SELECTOR = '[data-seve-section]';

function seveReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function seveInitReveal(root) {
  const targets = root.querySelectorAll('.seve-reveal');
  if (!targets.length) return;
  if (seveReducedMotion() || !('IntersectionObserver' in window)) {
    root.setAttribute('data-seve-anim', 'false');
    targets.forEach((el) => el.classList.add('is-in'));
    return;
  }
  root.setAttribute('data-seve-anim', 'true');
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
  );
  targets.forEach((el) => {
    if (el.dataset.seveObserved === 'true') return;
    el.dataset.seveObserved = 'true';
    observer.observe(el);
  });
}

function seveInitScrollToBuy(root) {
  root.querySelectorAll('[data-seve-scroll-to-buy]').forEach((el) => {
    if (el.dataset.seveBound === 'true') return;
    el.dataset.seveBound = 'true';
    el.addEventListener('click', (event) => {
      const target =
        document.querySelector('[data-seve-buy-anchor]') ||
        document.querySelector('[id^="ProductInformation-"]') ||
        document.querySelector('.product-details');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({
        behavior: seveReducedMotion() ? 'auto' : 'smooth',
        block: 'start',
      });
      const focusable =
        target.querySelector('button[name="add"]:not([disabled])') ||
        target.querySelector('select[name="id"]') ||
        target.querySelector('button:not([disabled]), a[href], input, select');
      if (!focusable) return;
      window.setTimeout(() => focusable.focus({ preventScroll: true }), 500);
    });
  });
}

function seveInitMarquee(root) {
  root.querySelectorAll('[data-seve-marquee]').forEach((el) => {
    const speed = parseInt(el.dataset.seveMarquee, 10);
    if (!Number.isNaN(speed) && speed > 0) {
      el.style.setProperty('--seve-marquee-duration', speed + 's');
    }
  });
}

/* Carrousel d’avis.
   1. Le scroll-snap passe de « mandatory » à « proximity » : quand la piste ne dépasse
      que de quelques dizaines de pixels (écrans très larges), un snap obligatoire ramène
      la position au seul point d’accroche atteignable — 0 — et les flèches semblent inertes.
   2. Repli instantané si le défilement animé n’aboutit pas (navigateurs ou environnements
      qui ignorent « behavior: smooth »).
   3. Les flèches se masquent quand il n’y a rien à faire défiler et se désactivent
      en début et en fin de piste. */
function seveInitCarousel(root) {
  root.querySelectorAll('[data-seve-carousel]').forEach((track) => {
    const wrap = track.closest('[data-seve-carousel-wrap]');
    if (!wrap) return;

    track.style.scrollSnapType = 'x proximity';

    const buttons = wrap.querySelectorAll('[data-seve-carousel-prev], [data-seve-carousel-next]');

    const syncButtons = () => {
      const max = track.scrollWidth - track.clientWidth;
      const scrollable = max > 4;
      buttons.forEach((btn) => {
        btn.hidden = !scrollable;
        if (!scrollable) return;
        const isNext = btn.hasAttribute('data-seve-carousel-next');
        btn.disabled = isNext ? track.scrollLeft >= max - 2 : track.scrollLeft <= 2;
      });
    };

    if (track.dataset.seveBound !== 'true') {
      track.dataset.seveBound = 'true';

      buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const dir = btn.hasAttribute('data-seve-carousel-next') ? 1 : -1;
          const card = track.querySelector(':scope > *');
          const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
          const step = card ? card.getBoundingClientRect().width + gap : 320;
          const max = track.scrollWidth - track.clientWidth;
          const from = track.scrollLeft;
          const target = Math.max(0, Math.min(max, from + dir * step));
          if (Math.abs(target - from) < 2) return;

          track.scrollTo({ left: target, behavior: seveReducedMotion() ? 'auto' : 'smooth' });

          window.setTimeout(() => {
            if (Math.abs(track.scrollLeft - from) < 2) {
              track.scrollLeft = target;
            }
            syncButtons();
          }, 450);
        });
      });

      track.addEventListener('scroll', syncButtons, { passive: true });
      window.addEventListener('resize', syncButtons, { passive: true });
    }

    syncButtons();
  });
}

function seveInit(scope) {
  const container = scope && scope.querySelectorAll ? scope : document;
  const roots = container.matches && container.matches(SEVE_SECTION_SELECTOR)
    ? [container]
    : Array.from(container.querySelectorAll(SEVE_SECTION_SELECTOR));
  roots.forEach((root) => {
    seveInitReveal(root);
    seveInitScrollToBuy(root);
    seveInitMarquee(root);
    seveInitCarousel(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => seveInit(document));
} else {
  seveInit(document);
}

window.addEventListener('load', () => seveInit(document));

document.addEventListener('shopify:section:load', (event) => seveInit(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-seve-observed]').forEach((el) => {
    delete el.dataset.seveObserved;
  });
});
document.addEventListener('shopify:block:select', (event) => {
  const details = event.target.closest ? event.target.closest('details') : null;
  if (details) details.open = true;
});